module.exports = __webpack_public_path__ + "img/growmark.10b80bbc.jpg";